import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Table from 'components/Shared/TableNew/Index'
import TableHead from 'components/Shared/TableNew/TableHead'
import TableBody from 'components/Shared/TableNew/TableBody'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import TableRowNoData from 'components/Shared/TableNew/TableRowNoData'
import RequestsTableRow from './RequestsTableRow'

const PartnerAppRequestsTable = ({ requests, selectedRequestId, onRowClick }) => {
  const { t } = useTranslation()

  return (
    <Table width='100%'>
      <TableHead withTopBorder>
        <TableRow>
          <TableCell colSpan='3'>{t('appRequestsPage.tableHeaderRequest')}</TableCell>
          <TableCell>{t('appRequestsPage.tableHeaderExecutedAt')}</TableCell>
          <TableCell>{t('appRequestsPage.tableHeaderResponseTime')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {requests.map(request => {
          const isSelected = selectedRequestId === request.id

          return (
            <RequestsTableRow
              key={request.id}
              request={request}
              onClick={() => { onRowClick(request) }}
              isSelected={isSelected}
            />
          )
        })}
        <TableRowNoData
          data={requests}
        />
      </TableBody>
    </Table>
  )
}

PartnerAppRequestsTable.propTypes = {
  selectedRequestId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  requests: PropTypes.array.isRequired,
  onRowClick: PropTypes.func.isRequired,
}

export default PartnerAppRequestsTable
